<template>
  <ul class="values">
    <li class="values__item">
      <span class="values__item__text">{{ $t(`${namespace}.averageTicket`) }}</span>
      <span class="values__item__value">{{ data.averageFare | currency }}</span>
    </li>

    <li class="values__item">
      <span class="values__item__text">{{ $t(`${namespace}.rides`) }}</span>
      <span class="values__item__value">
        <span v-if="data.amount < 10000">{{ data.amount | formatNumber }}</span>
        <v-tooltip v-else top>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ data.amount | convertNumberToStringNotation }}</span>
          </template>
          <span>{{ data.amount | formatNumber }}</span>
        </v-tooltip>
      </span>
    </li>

    <li class="values__item">
      <span class="values__item__text">{{ $t(`${namespace}.totalSpend`) }}</span>
      <span class="values__item__value">
        <span v-if="data.totalFare < 10000">{{ data.totalFare | currency }}</span>
        <v-tooltip v-else top>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ currencySymbol }}{{ data.totalFare | convertNumberToStringNotation }}
            </span>
          </template>
          <span>{{ data.totalFare | currency }}</span>
        </v-tooltip>
      </span>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import { convertToCurrency } from 'utils/functions'

export default {
  name: 'Values',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      selectedlocaleDate: ({ locale }) => locale.symbols.date
    }),

    currencySymbol () {
      return convertToCurrency(0).replace(/([\d,.]+)/, '')
    }
  },
  data () {
    return {
      namespace: 'Components.Performance'
    }
  }
}
</script>

<style lang="scss" scoped>
.values {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.values__item {
  display: flex;
  flex-direction: column;

  + .values__item {
    margin-left: 12px;

    @media (min-width: 768px) {
      margin-left: 26px;
    }
  }
}

.values__item__value,
.values__item__text {
  color: var(--gray-7);
  line-height: 1;
}

.values__item__text {
  font-size: 11px;
  margin-bottom: 8px;

  @media (min-width: 768px) {
    font-size: $base-font-size;
  }
}

.values__item__value {
  font-family: $title-font;
  font-size: 16px;
  font-weight: 800;

  @media (min-width: 768px) {
    font-size: 22px;
  }
}
</style>
